import React from "react"
import PropTypes from "prop-types"

import dateTimeWithTimeFormat from '../utils/dateTimeWithTimeFormat'
import ChatTextArea from './ChatTextArea';

class ChatContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      msgs: [],
      textbox: '',
      loaded: false
    }

    this.loadMsgs = this.loadMsgs.bind(this)
    this.renderMsgs = this.renderMsgs.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
    this.updateText = this.updateText.bind(this)
    this.scrollToBottom = this.scrollToBottom.bind(this)
  }

  componentDidMount() {
    this.loadMsgs()
    this.markAsRead()
  }

  markAsRead() {
    $.ajax({
      url: `../markAsRead`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        convo_id: this.props.convoId,
      },
      success: (data) => {
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  loadMsgs() {
    $.ajax({
      url: `../getConvoMsgs`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        convo_id: this.props.convoId,
      },
      success: (data) => {
        this.setState({
          convo: JSON.parse(data.data.convo),
          msgs: JSON.parse(data.data.msgs),
          currentUser: JSON.parse(data.data.current_user),
          loaded: true
        }, () => this.scrollToBottom())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  sendMessage(msg) {
    $.ajax({
      url: `../sendMessage`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        convo_id: this.props.convoId,
        msg: msg
      },
      success: (data) => {
        this.setState({
          msgs: JSON.parse(data.data.msgs),
          textbox: ''
        }, () => this.scrollToBottom())
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  }

  renderMsgs() {
    return this.state.msgs.map((msg, i) => {
        return(
          <div key={i} className={msg.user.id === this.state.currentUser.id ? "self" : "other"}>
            <img
              onClick={() => window.location.assign(`/profile/${msg.user.slug}`)}
              src={msg.user.avatar_url === "medium/missing.png"  ? this.props.missingImg : msg.user.avatar_url }
              className="avatar_standard avatar"
            />
            <div className="chatboxmessagecontent">
              <p>{msg.body}</p>
              <p style={{fontWeight: 100}} className="time">{msg.user.preferred_name}, {dateTimeWithTimeFormat(msg.created_at)}</p>
            </div>
          </div>
        )
    })
  }

  updateText(text) {
    this.setState({
      textbox: text
    })
  }

  render() {
    if(!this.state.loaded) {
      return null
    }
    return(
      <div style={{position: 'fixed', width: '100%', zIndex: 11}}>
        <div className="chatWrapper">
          <div className="chatboxhead">
            <div
              className="closeChat"
              onClick={() => this.props.closeChat()}></div>
          </div>
          <div className="chatboxcontent">
            {this.renderMsgs()}
            <div style={{ float:"left", clear: "both" }}
               ref={(el) => { this.messagesEnd = el; }}>
            </div>
          </div>
          <ChatTextArea
            textbox={this.state.textbox}
            updateText={this.updateText}
            sendMessage={this.sendMessage}
           />
        </div>
      </div>
    )
  }

}

export default ChatContainer;
